import React from 'react';
import PropTypes from 'prop-types';
import {
  Link,
  AppContent,
  ButtonGroup,
  SubmitButton,
  Button,
} from '@common/components';
import { Col, Form, Input } from 'antd';

export function OnboardingListsForm({
  form,
  onFinish,
  initialValues,
  submitLabel,
  loading,
}) {
  return (
    <AppContent>
      <Col xl={10} lg={14} md={16} xs={24}>
        <Form
          layout="vertical"
          onFinish={onFinish}
          form={form}
          initialValues={initialValues}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'Please enter a name' }]}
          >
            <Input className="sra-large-input" />
          </Form.Item>
          <Form.Item
            label="Compliance Deadline Details"
            name="complianceDeadlineDetails"
            rules={[
              {
                required: true,
                message: 'Please enter a compliance deadline details',
              },
            ]}
          >
            <Input className="sra-large-input" />
          </Form.Item>
          <ButtonGroup>
            <Link to="/works/admin/templates/compliance-list">
              <Button size="md">Cancel</Button>
            </Link>
            <SubmitButton size="md" loading={loading}>
              {submitLabel}
            </SubmitButton>
          </ButtonGroup>
        </Form>
      </Col>
    </AppContent>
  );
}

OnboardingListsForm.propTypes = {
  form: PropTypes.object,
  loading: PropTypes.bool,
  submitLabel: PropTypes.string,
  onFinish: PropTypes.func,
  initialValues: PropTypes.shape({
    name: PropTypes.string,
    complianceDeadlineDetails: PropTypes.string,
  }),
};
